import competitionsAthletesList from '@/store/modules/competitions-athletes/competition-athletes-list'
import competitionsAthletesDelete from '@/store/modules/competitions-athletes/competitions-athletes-delete'
import competitionsAthletesAdd from '@/store/modules/competitions-athletes/competitions-athletes-add'

export default {
  competitionsAthletesList,
  competitionsAthletesDelete,
  competitionsAthletesAdd,
}
